export default function RaisedHandsBadge({ count, players, className = "" }) {
  if (!count) return null;

  const names = (players || []).slice(0, 2).map((p) => p.pseudo).join(", ");
  const more = (players || []).length > 2 ? ` +${(players || []).length - 2}` : "";

  return (
    <div
      className={className}
      style={{
        pointerEvents: "none",
        zIndex: 20,
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        padding: "8px 14px",
        background:
          "repeating-linear-gradient(45deg,rgba(245,158,11,.03) 0px,rgba(245,158,11,.03) 1px,transparent 1px,transparent 7px),rgba(4,5,15,.88)",
        border: "1px solid rgba(245,158,11,.4)",
        clipPath: "polygon(8px 0%,100% 0%,calc(100% - 8px) 100%,0% 100%)",
        backdropFilter: "blur(10px)",
        boxShadow:
          "0 0 18px rgba(245,158,11,.12), inset 0 0 0 1px rgba(245,158,11,.06)",
        fontFamily: "ui-monospace,'SF Mono',Menlo,monospace",
      }}
    >
      {/* Icône amber pulsée */}
      <div
        style={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          border: "1px solid rgba(245,158,11,.45)",
          background: "rgba(245,158,11,.12)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 14,
          flexShrink: 0,
          boxShadow: "0 0 10px rgba(245,158,11,.25)",
        }}
      >
        ✋
      </div>

      {/* Textes */}
      <div style={{ lineHeight: 1.3 }}>
        {/* Ligne 1 — compteur */}
        <div
          style={{
            fontSize: 10,
            fontWeight: 800,
            letterSpacing: ".1em",
            textTransform: "uppercase",
            color: "rgba(253,230,138,.95)",
            textShadow: "0 0 10px rgba(245,158,11,.4)",
          }}
        >
          {count} main{count > 1 ? "s" : ""} levée{count > 1 ? "s" : ""}
        </div>

        {/* Ligne 2 — pseudos */}
        {names && (
          <div
            style={{
              fontSize: 11,
              color: "rgba(226,232,240,.75)",
              maxWidth: 200,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontFamily: "ui-sans-serif,system-ui",
              fontWeight: 500,
              letterSpacing: "0",
            }}
          >
            {names}{more}
          </div>
        )}
      </div>
    </div>
  );
}